module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clubs"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.clubs,
      "empty-text": "No clubs"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Club Name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "primary_contact_name",
      "label": "Primary Contact Name",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "primary_contact_number",
      "label": "Primary Contact Number",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "booking_count",
      "label": "Booking Count",
      "header-align": "center"
    }
  }), _vm._v(" "), (_vm.userIsSuperAdmin) ? _c('el-table-column', {
    attrs: {
      "prop": "client_id",
      "label": "Client",
      "header-align": "center",
      "formatter": _vm.humaniseClient
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Operations",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('operations', {
          attrs: {
            "id": props.row.id,
            "disableMore": true
          },
          on: {
            "edit": function($event) {
              _vm.editClub(props.row)
            },
            "delete": function($event) {
              _vm.deleteClub(props.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1211e274","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clubs/ClubTable.vue
// module id = 922
// module chunks = 13